// src/components/Debug.js
import React from 'react';

function Debug() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Debug Information</h1>
      <div className="bg-gray-100 p-4 rounded">
        <h2 className="text-lg font-semibold mb-2">Environment Variables</h2>
        <pre className="bg-gray-800 text-white p-4 rounded overflow-auto">
          {JSON.stringify(
            {
              NODE_ENV: process.env.NODE_ENV,
              FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
              FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID
            }, 
            null, 
            2
          )}
        </pre>
      </div>
    </div>
  );
}

export default Debug;